export default __webpack_public_path__ + "static/media/1. AFS_Getwell Health SystemsInc_12312023 ending December 2023.305926e5.pdf";